"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "filters justify-between lg:items-end print:hidden" };
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_5 = { class: "flex items-center justify-center gap-2" };
const _hoisted_6 = { class: "text-left font-bold" };
const _hoisted_7 = { class: "flex items-center justify-center gap-2" };
const _hoisted_8 = { class: "text-left font-bold" };
const _hoisted_9 = { class: "flex items-center justify-center gap-2" };
const _hoisted_10 = { class: "text-left font-bold" };
const _hoisted_11 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_12 = { class: "text-right" };
const _hoisted_13 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_14 = { class: "text-right" };
const _hoisted_15 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_16 = { class: "text-center" };
const _hoisted_17 = { class: "flex flex-row gap-1 justify-center items-center print:hidden" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-envelope" }, null, -1);
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = {
    key: 1,
    class: "w-full bg-gray-dark text-white text-center font-bold p-4"
};
const _hoisted_23 = { class: "font-bold text-center" };
const _hoisted_24 = { class: "flex justify-center items-center mb-4" };
const _hoisted_25 = { class: "flex justify-center items-center" };
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const shop_1 = require("../../common/utils/shop");
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const i18n_1 = require("../../common/i18n");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PackingSlips',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const router = (0, vue_router_1.useRouter)();
        const packingSlips = (0, vue_3.ref)([]);
        const packingSlipItems = (0, vue_3.ref)([]);
        const defaultFilterStartDate = (0, vue_3.computed)(() => {
            let halfYearBeforeToday = new Date();
            halfYearBeforeToday.setMonth(halfYearBeforeToday.getMonth() - 6);
            return (0, shop_1.formatDate)(halfYearBeforeToday);
        });
        const defaultFilterEndDate = (0, vue_3.computed)(() => {
            return (0, shop_1.formatDate)(new Date());
        });
        const selectedPackingSlip = (0, vue_3.ref)(null);
        const packingSlipItemsModalIsOpen = (0, vue_3.ref)(false);
        const sendPackingSlipCopyInEmailModalIsOpen = (0, vue_3.ref)(false);
        const packingSlipCopyEmail = (0, vue_3.ref)("");
        const filter = (0, vue_3.ref)({
            startDate: defaultFilterStartDate.value,
            endDate: defaultFilterEndDate.value,
            packingSlipIdPartial: "",
        });
        const packingSlipListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("packing_slip_id_slip_list", "Packing Slip ID", "packing_slips")) !== null && _a !== void 0 ? _a : "Packing Slip ID",
                value: "id",
            },
            {
                key: "deliveryDate",
                label: (_b = (0, i18n_1.trans)("delivery_date_slip_list", "Delivery Date", "packing_slips")) !== null && _b !== void 0 ? _b : "Delivery Date",
                value: "deliveryDate",
            },
            {
                key: "deliveryAddress",
                label: (_c = (0, i18n_1.trans)("delivery_address_slip_list", "Delivery Address", "packing_slips")) !== null && _c !== void 0 ? _c : "Delivery Address",
                value: "deliveryAddress",
            },
            {
                key: "quantity",
                label: (_d = (0, i18n_1.trans)("quantity_slip_list", "Quantity", "packing_slips")) !== null && _d !== void 0 ? _d : "Quantity",
                value: "quantity",
            },
            {
                key: "netAmount",
                label: (_e = (0, i18n_1.trans)("net_amount_slip_list", "Net Amount", "packing_slips")) !== null && _e !== void 0 ? _e : "Net Amount",
                value: "netAmount",
            },
            {
                key: "deliveryMode",
                label: (_f = (0, i18n_1.trans)("delivery_mode_slip_list", "Delivery Mode", "packing_slips")) !== null && _f !== void 0 ? _f : "Delivery Mode",
                value: "deliveryMode",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const packingSlipItemListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_g = (0, i18n_1.trans)("item_id_slip_item_list", "Item ID", "packing_slips")) !== null && _g !== void 0 ? _g : "Item ID",
                value: "id",
            },
            {
                key: "name",
                label: (_h = (0, i18n_1.trans)("name_slip_item_list", "Name", "packing_slips")) !== null && _h !== void 0 ? _h : "Name",
                value: "name",
            },
            {
                key: "quantity",
                label: (_j = (0, i18n_1.trans)("quantity_slip_item_list", "Quantity", "packing_slips")) !== null && _j !== void 0 ? _j : "Quantity",
                value: "quantity",
            },
            {
                key: "salesUnit",
                label: (_k = (0, i18n_1.trans)("sales_unit_slip_item_list", "Sales Unit", "packing_slips")) !== null && _k !== void 0 ? _k : "Sales Unit",
                value: "salesUnit",
            },
            {
                key: "netAmount",
                label: (_l = (0, i18n_1.trans)("net_amount_slip_item_list", "Net Amount", "packing_slips")) !== null && _l !== void 0 ? _l : "Net Amount",
                value: "netAmount",
            },
        ]);
        const printPage = () => {
            window.print();
        };
        const getPackingSlips = async (query, customerId) => {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "axapta_packing_slips_api", query: { ...query, customerId: customerId } }).href);
                return response;
            }
            catch (error) {
                console.error("An error occurred while fetching packing slips:", error);
                throw error;
            }
        };
        const getPackingSlipItems = async (params) => {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "axapta_packing_slip_items_api", query: params }).href);
                return response;
            }
            catch (error) {
                console.error("An error occurred while fetching packing slip items:", error);
                throw error;
            }
        };
        const sendPackingSlipCopyInEmailAPI = async (payload) => {
            const options = { body: JSON.stringify(payload), method: "POST" };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "axapta_send_packing_slip_copy_in_email_api" }).href, options);
                if (response.status !== "success") {
                    throw new Error(response.error);
                }
                return response;
            }
            catch (error) {
                console.error("An error occurred while sending the packing slip via email:", error);
                throw error;
            }
        };
        const queryPackingSlips = async () => {
            var _a;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "packing_slips")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            if (filter.value.startDate === "") {
                filter.value.startDate = defaultFilterStartDate.value;
            }
            if (filter.value.endDate === "") {
                filter.value.endDate = defaultFilterEndDate.value;
            }
            try {
                const response = await getPackingSlips(filter.value, securityStore.authenticatedUser.customer.id);
                packingSlips.value = response;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const viewPackingSlipItems = async (packingSlip) => {
            var _a;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "packing_slips")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            selectedPackingSlip.value = packingSlip;
            packingSlipItems.value = [];
            try {
                const items = await getPackingSlipItems({ customerId: securityStore.authenticatedUser.customer.id, packingSlipId: packingSlip.id });
                packingSlipItems.value = items;
                packingSlipItemsModalIsOpen.value = true;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const openSendingPackingSlipCopyInEmailModal = (packingSlip) => {
            selectedPackingSlip.value = packingSlip;
            sendPackingSlipCopyInEmailModalIsOpen.value = true;
        };
        const sendPackingSlipCopyInEmail = async () => {
            var _a, _b;
            if (confirm((_a = (0, i18n_1.trans)("send_packing_slip_copy_confirm", `Are you really want to send packing slip copy to {email}`, "packing_slips", { email: packingSlipCopyEmail.value })) !== null && _a !== void 0 ? _a : `Are you really want to send packing slip copy to ${packingSlipCopyEmail.value}`)) {
                if (securityStore.authenticatedUser === null || selectedPackingSlip.value === null) {
                    toastStore.addErrorToast((_b = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "packing_slips")) !== null && _b !== void 0 ? _b : "There is no authenticated user");
                    return;
                }
                try {
                    await sendPackingSlipCopyInEmailAPI({
                        email: packingSlipCopyEmail.value,
                        packingSlipId: selectedPackingSlip.value.id,
                        customerId: securityStore.authenticatedUser.customer.id,
                    });
                    sendPackingSlipCopyInEmailModalIsOpen.value = false;
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("email_is_sent_successfully", "Email is sent successfully!", "packing_slips"),
                        type: "success",
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const formatDeliveryAddress = (packingSlip) => {
            return `${packingSlip.deliveryName} ${packingSlip.deliveryZipCode} ${packingSlip.deliveryCity} ${packingSlip.deliveryStreet}`;
        };
        (0, vue_3.onBeforeMount)(() => {
            packingSlips.value = [];
            packingSlipItems.value = [];
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('start_date_placeholder', 'Start Date', 'packing_slips'),
                            label: (0, vue_2.unref)(i18n_1.trans)('start_date_label', 'Start Date', 'packing_slips'),
                            modelValue: filter.value.startDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filter.value.startDate) = $event)),
                            class: "packing-slip-filter-input",
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('end_date_placeholder', 'End Date', 'packing_slips'),
                            label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'packing_slips'),
                            modelValue: filter.value.endDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filter.value.endDate) = $event)),
                            class: "packing-slip-filter-input",
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('packing_slip_id_placeholder', 'e.g.: SZ111000040', 'packing_slips'),
                            label: (0, vue_2.unref)(i18n_1.trans)('packing_slip_id_label', 'Packing Slip ID Partial', 'packing_slips'),
                            modelValue: filter.value.packingSlipIdPartial,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filter.value.packingSlipIdPartial) = $event)),
                            class: "packing-slip-filter-input",
                            type: "text",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-warning h-[48px]",
                            onClick: _cache[3] || (_cache[3] = ($event) => (printPage()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return_list")), 1),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary h-[48px]",
                            onClick: queryPackingSlips
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit_query", "Submit Query", "packing_slips")), 1)
                    ])
                ]),
                (packingSlips.value.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                        key: 0,
                        fields: packingSlipListFields.value,
                        "onUpdate:fields": _cache[4] || (_cache[4] = ($event) => ((packingSlipListFields).value = $event)),
                        items: packingSlips.value,
                        striped: "",
                        condensed: "",
                        panel: ""
                    }, {
                        "head-id": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("packing_slip_id", "Packing Slip ID", "packing_slips")), 1)
                        ]),
                        "cell-id": (0, vue_2.withCtx)(({ item: packingSlip }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(packingSlip.id), 1)
                        ]),
                        "head-deliveryDate": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_date", "Delivery Date", "packing_slips")), 1)
                        ]),
                        "cell-deliveryDate": (0, vue_2.withCtx)(({ item: packingSlip }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(packingSlip.deliveryDate), 1)
                        ]),
                        "head-deliveryAddress": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_address", "Delivery Address", "packing_slips")), 1)
                        ]),
                        "cell-deliveryAddress": (0, vue_2.withCtx)(({ item: packingSlip }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)(formatDeliveryAddress(packingSlip)), 1)
                        ]),
                        "head-quantity": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("quantity", "Quantity", "packing_slips")), 1)
                        ]),
                        "cell-quantity": (0, vue_2.withCtx)(({ item: packingSlip }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)(packingSlip.quantity), 1)
                        ]),
                        "head-netAmount": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("net_amount", "Net Amount", "packing_slips")), 1)
                        ]),
                        "cell-netAmount": (0, vue_2.withCtx)(({ item: packingSlip }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(packingSlip.netAmount), 1)
                        ]),
                        "head-deliveryMode": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_mode", "Delivery Mode", "packing_slips")), 1)
                        ]),
                        "cell-deliveryMode": (0, vue_2.withCtx)(({ item: packingSlip }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)(packingSlip.deliveryMode), 1)
                        ]),
                        "cell-actions": (0, vue_2.withCtx)(({ item: packingSlip }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-primary btn-link",
                                    onClick: ($event) => (viewPackingSlipItems(packingSlip))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("view_packing_slip_items", "View Packing Slip Items", "packing_slips")), 9, _hoisted_18),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-danger btn-link",
                                    onClick: ($event) => (openSendingPackingSlipCopyInEmailModal(packingSlip))
                                }, _hoisted_21, 8, _hoisted_19)
                            ])
                        ]),
                        _: 1
                    }, 8, ["fields", "items"]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("no_packing_slips_to_display", "No packing slips to display", "packing_slips")), 1)),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: packingSlipItemsModalIsOpen.value,
                    title: selectedPackingSlip.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('view_packing_slip', 'View Packing Slip - Packing Slip ID: {id}', 'packing_slips', { id: selectedPackingSlip.value.id })
                        : '',
                    onClose: _cache[6] || (_cache[6] = ($event) => (packingSlipItemsModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (packingSlipItems.value.length > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                                key: 0,
                                fields: packingSlipItemListFields.value,
                                "onUpdate:fields": _cache[5] || (_cache[5] = ($event) => ((packingSlipItemListFields).value = $event)),
                                items: packingSlipItems.value,
                                striped: "",
                                condensed: "",
                                panel: ""
                            }, {
                                "cell-quantity": (0, vue_2.withCtx)(({ item: packingSlipItem }) => [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(packingSlipItem.quantity), 1)
                                ]),
                                "cell-netAmount": (0, vue_2.withCtx)(({ item: packingSlipItem }) => [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(packingSlipItem.netAmount), 1)
                                ]),
                                _: 1
                            }, 8, ["fields", "items"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: sendPackingSlipCopyInEmailModalIsOpen.value,
                    title: selectedPackingSlip.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('send_packing_slip_copy_in_email', 'Send Packing Slip Copy In Email - Packing Slip ID: {id}', 'packing_slips', { id: selectedPackingSlip.value.id })
                        : '',
                    onClose: _cache[8] || (_cache[8] = ($event) => (sendPackingSlipCopyInEmailModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("the_selected_packing_slip_copy_can_be_sent_in_PDF", "The selected packing slip copy can be sent in PDF format to the given email address.", "packing_slips")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_24, [
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                label: (0, vue_2.unref)(i18n_1.trans)('email_address', 'Email address', 'packing_slips'),
                                modelValue: packingSlipCopyEmail.value,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((packingSlipCopyEmail).value = $event)),
                                class: "w-[300px]",
                                type: "email",
                                required: "",
                                border: ""
                            }, null, 8, ["label", "modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_25, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary inline",
                                onClick: sendPackingSlipCopyInEmail
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("send_email", "Send Email", "packing_slips")), 1)
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
